import { render, staticRenderFns } from "./HomeOrg.vue?vue&type=template&id=3aa37aba&scoped=true&"
import script from "./HomeOrg.vue?vue&type=script&lang=js&"
export * from "./HomeOrg.vue?vue&type=script&lang=js&"
import style0 from "./HomeOrg.vue?vue&type=style&index=0&id=3aa37aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa37aba",
  null
  
)

export default component.exports